<template>
    <v-app>
        <page-nav></page-nav>
        <!-- Sizes your content based upon application components -->
        <v-content>
            <!-- Provides the application the proper gutter -->
            <!-- <v-container fluid class="mt-n3"> -->
            <v-container fluid>
                <!-- If using vue-router -->
                <router-view></router-view>
            </v-container>
        </v-content>

        <page-footer></page-footer>
        <RebrandingSiteModal />
    </v-app>
</template>

<script>
import PageNav from '@/components/Nav/navbar';
import PageFooter from '@/components/Footer';
import RebrandingSiteModal from '@/components/modals/RebrandingSiteModal';

export default {
    name: 'App',
    components: { PageNav, PageFooter, RebrandingSiteModal },
    metaInfo() {
        return {
            title: 'Nexon Game Card',
            meta: [
                {
                    name: 'description',
                    content: 'Nexon Game Card, The Online Game Card',
                },
                {
                    name: 'keywords',
                    content:
                        'Nexon Game Card, NexonGameCard, nexongamecard.com, Nexon Game Card balance, Nexon, eGift Card, Nexon Card',
                },
                { property: 'og:type', content: 'website' },
                {
                    property: 'og:url',
                    content: 'https://www.nexongamecard.com',
                },
                { property: 'og:title', content: 'Nexon Game Card' },
                {
                    property: 'og:description',
                    content: 'Nexon Game Card, The Online Game Card',
                },
                {
                    property: 'og:image',
                    content:
                        'https://www.nexongamecard.com/img/logo.56cb60a2.svg',
                },
                { itemprop: 'name', content: 'Nexon Game Card' },
                {
                    itemprop: 'description',
                    content: 'Nexon Game Card, The Online Game Card',
                },
                {
                    itemprop: 'image',
                    content:
                        'https://www.nexongamecard.com/img/logo.56cb60a2.svg',
                },
            ],
        };
    },
};
</script>

<style lang="scss" scoped>
.v-content {
    padding-top: 0 !important;
    .container {
        height: 100%;
        padding: 0;
    }
}
@include break('xl') {
    .v-content {
        max-width: 1920px;
        margin: 0 auto;
        width: 100%;
    }
}
</style>
